import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { Button } from '@upme/ui/components/button';
import { listCitiesOptions } from '../../../features/cities/queries';
import { UsersFilters } from '../../../features/users/components/users-filters';
import { UsersTable } from '../../../features/users/components/users-table';
import { listUsersOptions } from '../../../features/users/queries';
import { PageHeader } from '../../../shared/components/page-header';
import { Route as UsersRoute } from './route';

export const Route = createFileRoute('/_authenticated/users/')({
  loader: ({ context }) => context.queryClient.ensureQueryData(listCitiesOptions()),
  component: UsersIndexPage,
});

function UsersIndexPage() {
  const search = UsersRoute.useSearch();
  const { data: cities } = useSuspenseQuery(listCitiesOptions());
  const { data } = useSuspenseQuery(listUsersOptions(search));

  return (
    <div>
      <PageHeader
        title="Пользователи"
        description="Реестр аккаунтов: кто зарегистрировался, когда заходил и откуда пришёл."
        actions={
          <Button asChild variant="outline">
            <Link to="/users/fakes">Фейковые аккаунты →</Link>
          </Button>
        }
      />
      <UsersFilters cities={cities} value={search} />
      <UsersTable users={data.items} cities={cities} total={data.total} page={data.page} limit={data.limit} />
    </div>
  );
}
